import { ivrApi as defaultIvrApi } from "@b2bportal/ivr-api";
import axios from "axios";

// TODO create a core-ivr library and move this there along with
// components to fetch/render the support ID
//
// Pair core-chat with chatApi once components are migrated over
// that use those API functions
export const ivrApi = defaultIvrApi(axios);
